import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getReportIssue = (payload) => {
  return axios
    .get(`${URL_ORI}/api/ReportIssue/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createReportIssue = (payload) => {
  return axios.post(`${URL_ORI}/api/ReportIssue`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdReportIssue = (id) => {
  return axios
    .get(`${URL_ORI}/api/ReportIssue/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateReportIssue = (payload) => {
  return axios.put(`${URL_ORI}/api/ReportIssue`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateReportIssueAll = (payload) => {
  return axios
    .put(`${URL_ORI}/api/ReportIssue/ResolveAll`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteReportIssue = (payload) => {
  return axios.delete(`${URL_ORI}/api/ReportIssue`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createReportIssueUpload = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios
    .post(`${URL_ORI}/api/ReportIssue/uploadVehicle`, formData)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createReportIssueUploadResolve = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios
    .post(`${URL_ORI}/api/ReportIssue/UploadVehicleResolve`, formData)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getFile = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Miscellanous/ConvertJsonToExcelMisc`, {
      params: payload,
      // responseType: "blob",
    })
    .catch((error) => {
      if (error.response) {
        console.log(error.response, "eerorr");

        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getFileBlob = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Miscellanous/ConvertJsonToExcelMisc`, {
      params: payload,
      responseType: "blob",
    })
    .catch((error) => {
      if (error.response) {
        console.log(error.response, "eerorr");

        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getReportIssueDownload = (payload) => {
  return axios
    .get(`${URL_ORI}/api/ReportIssue/ReportIssueDownload`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
